var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.smAndUp),expression:"$vuetify.breakpoint.smAndUp"}],staticClass:"material-card mt-0 mb-2 transparent",staticStyle:{"position":"relative","z-index":"0"},attrs:{"flat":"","outlined":"","height":"230"}},'v-card',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }